// src/plugins/logger.js
import Vue from "vue";
import { IS_PROD } from "../util/globals";

/**
 * Safe logger for both AxiosResponse and AxiosError
 * @param {import('axios').AxiosResponse|import('axios').AxiosError|any} answer
 */
export const loggerApi = (answer) => {
  // Toggle & level
  const active = !IS_PROD;             // true in dev, false in prod
  const level  = IS_PROD ? 1 : 4;      // 1..4 verbosity

  if (!active)
    return;

  // Normalize shapes
  // AxiosResponse: { config, status, data, ... }
  // AxiosError: { config, request, response?, message, ... }
  const isError   = !!answer?.isAxiosError;
  const cfg       = answer?.config || answer?.response?.config || null;
  const res       = isError ? answer?.response : answer;
  const req       = answer?.request || res?.request || null;

  // method / url
  const method    = (cfg?.method || "").toUpperCase();
  const baseURL   = cfg?.baseURL || "";
  const url       = cfg?.url || "";
  const api       = `${baseURL}${baseURL && url ? " " : ""}${url}`;

  // status resolution (may be undefined on pure network errors/timeouts)
  const status =
    res?.status ??
    req?.status ?? // some adapters set it
    (isError ? undefined : answer?.status);

  // pick what to print as "response"
  // on success -> res; on error -> either res (if exists) or the error itself
  const printable =
    !isError ? res : (res ?? { message: answer?.message, stack: answer?.stack });

  // ---- output based on level ----
  console.log(`<---api called--->`);
  if (level >= 1) {
    console.log(`${method || "UNKNOWN"} - ${api || "NO_URL"} - ${status ?? "NO_STATUS"}`);
  }
  if (level >= 2) {
    console.log(`isError : ${isError}`);
  }
  if (level >= 3) {
    console.log(`request :`, {
      headers: cfg?.headers,
      params:  cfg?.params,
      data:    cfg?.data,
      timeout: cfg?.timeout,
      responseType: cfg?.responseType,
    });
  }
  if (level >= 4) {
    console.log(`response :`, printable);
  }
  console.log(`<---api ended---/>`);
  console.log("-----");
};

// Vue plugin
const logger = {
  install(Vue) {
    // Keep the same signature as loggerApi: pass the whole axios object (response or error)
    Vue.prototype.$loggerApi = (answer) => loggerApi(answer);
  },
};

Vue.use(logger);